import twMerge from 'twMerge';

import Section from 'molecules/Section';

import getTheme from 'utils/getTheme';
import richTextParser from 'utils/richTextParser/richTextParser';

import type { SectionProps } from 'molecules/Section';

type WrenchProps = {
  background?: SectionProps['background'];
  body?: { raw?: string };
  contentful_id?: string;
  heading?: string;
  itemBody1?: string;
  itemBody2?: string;
  itemBody3?: string;
  itemHeading1?: string;
  itemHeading2?: string;
  itemHeading3?: string;
  padding?: string;
  sectionIdLink?: string;
};

const Wrench = ({
  background,
  body,
  contentful_id,
  heading,
  itemBody1,
  itemBody2,
  itemBody3,
  itemHeading1,
  itemHeading2,
  itemHeading3,
  padding,
  sectionIdLink,
}: WrenchProps) => {
  const theme = getTheme(background || 'white');

  const items = [
    { heading: itemHeading1, body: itemBody1 },
    { heading: itemHeading2, body: itemBody2 },
    { heading: itemHeading3, body: itemBody3 },
  ];

  const renderWrenchItem = (itemHeading?: string, itemBody?: string) => {
    if (!itemHeading && !itemBody) {
      return null;
    }

    return (
      <div className="wrench-item flex flex-col items-center text-center">
        {itemHeading && (
          <p
            className={twMerge(
              'wrench-item-heading text-[28px] font-bold md:text-[44px]',
              theme === 'dark' ? 'text-white' : 'text-gray-900',
            )}
          >
            {itemHeading}
          </p>
        )}
        {itemBody && (
          <p
            className={twMerge(
              'wrench-item-body mt-2 text-md md:text-lg',
              theme === 'dark' ? 'text-white' : 'text-gray-900',
            )}
          >
            {itemBody}
          </p>
        )}
      </div>
    );
  };

  return (
    <Section
      id={sectionIdLink}
      background={background}
      padding={padding}
      contained={false}
      contentfulId={contentful_id}
    >
      <div className="wrench flex flex-col items-center gap-12 md:gap-16">
        <div className="wrench-heading flex w-full flex-col items-center">
          {heading && (
            <h2
              className={twMerge(
                'text-[26px] font-bold md:text-[36px]',
                theme === 'dark' ? 'text-white' : 'text-gray-900',
              )}
            >
              {heading}
            </h2>
          )}
          {body && (
            <div
              className={twMerge(
                'mt-3 max-w-[800px] text-center text-xs md:mt-6 md:text-sm',
                theme === 'dark' ? '[&>*]:!text-white' : '[&>*]:text-gray-900',
              )}
            >
              {richTextParser(body as RichText)}
            </div>
          )}
        </div>
        <div className="wrench-items grid w-full grid-cols-1 gap-8 px-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map(({ heading: itemHeading, body: itemBody }) => renderWrenchItem(itemHeading, itemBody))}
        </div>
      </div>
    </Section>
  );
};

export default Wrench;
